import type { FC } from "react";

import {
  HORIZONTAL_CARD_DEFAULTS,
  THorizontalCardProps,
} from "@/ui/components/data-display/Card/Card.config";

import { BaseCard } from "./BaseCard";
import { CardIntroduction } from "./CardIntroduction";
import { CardContent } from "./CardContent";
import { cn } from "@/ui/lib/utils";

export const HorizontalCard: FC<THorizontalCardProps> = (
  {
    image,
    title,
    description,
    eyebrow,
    orientation = HORIZONTAL_CARD_DEFAULTS.orientation,
    tags,
    children,
    className,
    ...props
  },
) => (
  <BaseCard
    data-component="HorizontalCard"
    image={{ fit: "cover", ...image }}
    ratio="4:3"
    layout="row"
    orientation={orientation}
    tags={tags}
    className={cn(
      "bg-white",
      className,
    )}
    {...props}
  >
    <CardIntroduction
      title={title}
      eyebrow={eyebrow}
      description={description}
      titleWrap="wrap"
    />
    <CardContent>
      { children }
    </CardContent>
  </BaseCard>
);

HorizontalCard.displayName = "PreviewCard";
